import router from "@/plugins/router";

export default {
  state: {
    giftcards: [],
    promos: [],
    newsFeeds: [],
    newsFeedPopupDid: false,
  },

  getters: {
    memberEnabled: (state, getters) => {
      if (getters.service) {
        return getters.serviceSessionKey && getters.service.memberEnabled;
      } else return false;
    },

    memberOptional: (state, getters) => {
      if (getters.service) {
        return getters.memberEnabled && getters.service.memberOptional;
      } else return false;
    },

    memberTransferEnabled: (state, getters) => {
      if (getters.service) {
        return getters.serviceSessionKey && getters.service.memberTransferEnabled;
      } else return false;
    },

    memberEmailRequired: (state, getters) => {
      if (getters.service) {
        return getters.service.memberEmailRequired === true;
      } else return false;
    },

    memberEmailHide: (state, getters) => {
      if (getters.service) {
        return getters.service.memberEmailHide === true;
      } else return false;
    },

    memberMonthOfBirthRequired: (state, getters) => {
      if (getters.service) {
        return getters.service.memberMonthOfBirthRequired === true;
      } else return false;
    },

    memberMonthOfBirthHide: (state, getters) => {
      if (getters.service) {
        return getters.service.memberMonthOfBirthHide === true;
      } else return false;
    },

    memberDayOfBirthRequired: (state, getters) => {
      if (getters.service) {
        return getters.service.memberDayOfBirthRequired === true;
      } else return false;
    },

    memberDayOfBirthHide: (state, getters) => {
      if (getters.service) {
        return getters.service.memberDayOfBirthHide === true;
      } else return false;
    },

    memberYearOfBirthHide: (state, getters) => {
      if (getters.service) {
        return getters.service.memberYearOfBirthHide === true;
      } else return false;
    },

    memberLoginMessage: (state, getters, rootState) => {
      let message = getters.service.memberLoginMessages["def"];
      if (rootState.languageSelected) {
        if (getters.service.memberLoginMessages[rootState.languageSelected.locale])
          message = getters.service.memberLoginMessages[rootState.languageSelected.locale];
      }

      return message;
    },

    memberCode: (state, getters, rootState) => {
      let code = "";
      if (rootState.member) {
        code = rootState.member.MemberCode;
      }
      return code;
    },

    memberName: (state, getters, rootState) => {
      let name = "";
      if (rootState.member) {
        name = rootState.member.MemberFirstName ? rootState.member.MemberFirstName.trim() : "";
        if (name == "") name = rootState.member.MemberLastName ? rootState.member.MemberLastName.trim() : "";
      }
      return name;
    },

    memberFullName: (state, getters, rootState) => {
      let name = "";
      if (rootState.member) {
        name = rootState.member.MemberFirstName ? rootState.member.MemberFirstName.trim() : "";
        name +=
          (name == "" ? "" : " ") + (rootState.member.MemberLastName ? rootState.member.MemberLastName.trim() : "");
      }
      return name;
    },

    memberPhoneId: (state, getters, rootState) => {
      let phoneId = "";
      if (rootState.member) {
        phoneId = rootState.member.PhoneId;
      }
      return phoneId;
    },

    memberPhoneNo: (state, getters, rootState) => {
      let phoneNo = "";
      if (rootState.member && rootState.member.MemberAddress) {
        phoneNo = rootState.member.MemberAddress.AddrPhone1;
      }
      return phoneNo;
    },

    // use to send message
    memberMessageNo: (state, getters) => {
      let msgNo = getters.memberPhoneId;
      if (!msgNo && getters.memberPhoneNo) {
        msgNo = getters.memberPhoneNo;
        if (!msgNo.startsWith("+1")) msgNo = "+1" + msgNo;
      }
      return msgNo;
    },

    memberEmail: (state, getters, rootState) => {
      let email = "";
      if (rootState.member) {
        email = rootState.member.MemberEMail;
      }
      return email;
    },

    memberVip: (state, getters, rootState) => {
      let vip = false;
      if (rootState.member) {
        vip =
          (rootState.member.MemberMetadata.MemberExVIP && rootState.member.MemberMetadata.MemberExVIP === true) ||
          rootState.member.VipCode;
      }

      return vip;
    },

    memberVipExpiryDate: (state, getters, rootState) => {
      let vipExpiryDate = null;
      if (rootState.member && rootState.member.MemberMetadata.VIPExpiryDate) {
        try {
          vipExpiryDate = new Date(rootState.member.MemberMetadata.VIPExpiryDate);
          if (!(vipExpiryDate instanceof Date) || isNaN(vipExpiryDate)) vipExpiryDate = null;
        } catch (error) {
          vipExpiryDate = null;
        }
      }

      //console.log("memberVipExpiryDate", vipExpiryDate);

      return vipExpiryDate;
    },

    memberValidVip: (state, getters) => {
      let vip = getters.memberVip;

      if (vip && getters.memberVipExpiryDate) {
        const today = new Date();
        vip = today <= getters.memberVipExpiryDate;
      }
      return vip;
    },

    memberCompanyCode: (state, getters, rootState) => {
      let n_companyCode = null;
      if (rootState.member && rootState.member.CompanyCode) {
        n_companyCode = rootState.member.CompanyCode;
      }

      return n_companyCode;
    },

    memberCompanyName: (state, getters, rootState) => {
      let n_companyName = null;
      if (rootState.member && rootState.member.CompanyName) {
        n_companyName = rootState.member.CompanyName;
      }

      return n_companyName;
    },

    memberMerchants: (state, getters, rootState) => {
      let n_merchants = null;
      if (rootState.member && rootState.member.Merchants) {
        n_merchants = rootState.member.Merchants;
      }

      return n_merchants;
    },

    memberStripeEnabled: (state, getters) => {
      let merchants = getters.memberMerchants;
      return merchants && merchants.includes("stripe");
    },

    memberGlobalPaymentEnabled: (state, getters) => {
      let merchants = getters.memberMerchants;
      return merchants && merchants.includes("globalPayment");
    },

    memberFavoriteStores: (state, getters, rootState) => {
      let fav = [];
      if (rootState.member && rootState.member.MemberMetadata) {
        let metadata = rootState.member.MemberMetadata;
        if (metadata.FavoriteStores && Array.isArray(metadata.FavoriteStores)) fav = metadata.FavoriteStores;
      }

      return fav;
    },

    newMemberAddCard: (state, getters) => {
      if (getters.service) {
        return getters.service.newMemberAddCard;
      } else return false;
    },

    newCardPrefix: (state, getters) => {
      if (getters.service) {
        return getters.service.newCardPrefix;
      } else return "";
    },

    giftcardEnabled: (state, getters) => {
      return getters.memberEnabled && getters.service.giftcardEnabled === true;
    },

    giftcardReloaEnabled: (state, getters) => {
      return getters.giftcardEnabled && getters.service.giftcardReloadEnabled === true;
    },

    giftcardPaymentEnabled: (state, getters) => {
      return getters.giftcardEnabled && getters.service.giftcardPaymentEnabled === true;
    },

    giftcardAmountFormat: (state, getters) => {
      return getters.storeService?.giftcardAmountFormat;
    },

    giftcardBalance: state => {
      let giftcardBalance = 0;
      if (state.giftcards) {
        state.giftcards.forEach(r => {
          giftcardBalance += r.CurBalance;
        });
      }

      return giftcardBalance;
    },

    giftcardSecurityCode: (state, getters) => {
      return getters.memberEnabled && getters.service.giftcardSecurityCode;
    },

    pointEnabled: (state, getters) => {
      return getters.memberEnabled && getters.service.pointEnabled;
    },

    pointRedeemEnabled: (state, getters) => {
      return getters.memberEnabled && getters.service.pointRedeemEnabled;
    },

    availablePromos: (state, getters, rootState) => {
      if (state.promos == null) return [];
      else if (rootState.Order.order.orderItems) {
        let redeemedPromoOIs = rootState.Order.order.orderItems.filter(oi => oi.promo);
        let redeemedPromoCodes = [];
        if (redeemedPromoOIs) {
          redeemedPromoOIs.forEach(oi => {
            redeemedPromoCodes.push(oi.promo.PromoteCode);
          });
        }

        let avaPromos = state.promos.filter(
          promo =>
            !redeemedPromoCodes.includes(promo.PromoteCode) &&
            (promo.CustomData == null ||
              promo.CustomData.OrderTypes == null ||
              promo.CustomData.OrderTypes.includes(rootState.Order.order.orderType) ||
              rootState.Order.order.orderType == "") &&
            (promo.CustomData == null || promo.CustomData.Hide == null || !promo.CustomData.Hide)
        );
        if (avaPromos == null) avaPromos = [];

        return avaPromos;
      }
    },

    newsFeeds: (state, getters, rootState) => {
      return state.newsFeeds.filter(
        nf =>
          (nf.CustomData.Hide == null || !nf.CustomData.Hide) &&
          (nf.CustomData.orderTypes == null ||
            (["MenuFull", "menuCategory"].includes(router.currentRoute.name) &&
              nf.CustomData.orderTypes.includes(rootState.Order.order.orderType)))
      );
    },

    newsFeedsPopup: (state, getters, rootState) => {
      return state.newsFeeds.filter(
        nf =>
          nf.CustomData.Popup === true &&
          (nf.CustomData.orderTypes == null ||
            (["MenuFull", "menuCategory"].includes(router.currentRoute.name) &&
              nf.CustomData.orderTypes.includes(rootState.Order.order.orderType)))
      );
    },

    newsFeedPopup: (state, getters, rootState) => {
      let nf = null;
      if (getters.newsFeedsPopup.length > 0 && !rootState.Member.newsFeedPopupDid) {
        let randomIndex = Math.floor(Math.random() * getters.newsFeedsPopup.length);
        nf = getters.newsFeedsPopup[randomIndex];
      }
      return nf;
    },

    newsFeedsVisible: (state, getters) => {
      return getters.newsFeeds.length > 0;
    },
  },

  mutations: {
    giftcards(state, payload) {
      state.giftcards = payload;
    },

    promos(state, payload) {
      state.promos = payload;
    },

    newsFeeds(state, payload) {
      state.newsFeeds = payload;
    },

    newsFeedPopupDid(state, payload) {
      state.newsFeedPopupDid = payload;
    },
  },

  actions: {},
};
